import { render, staticRenderFns } from "./VSwitcher.vue?vue&type=template&id=66d4973b&scoped=true"
import script from "./VSwitcher.vue?vue&type=script&lang=js"
export * from "./VSwitcher.vue?vue&type=script&lang=js"
import style0 from "./VSwitcher.vue?vue&type=style&index=0&id=66d4973b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4973b",
  null
  
)

export default component.exports